export default {
  application: {
    'zh-CN': "\u7B80\u4F53\u4E2D\u6587",
    'en-US': 'English',
    productTitle: "\u8868\u5355\u8BBE\u8BA1\u5668",
    github: 'GitHub',
    document: "\u6587\u6863",
    qqGroup: "\u6280\u672FWX\u7FA4",
    deployment: "\u79C1\u6709\u90E8\u7F72",
    subscription: "\u8BA2\u9605Pro"
  },
  designer: {
    chartLib: "\u56FE\u8868",
    metadataLib: "\u5143\u6570\u636E",
    componentLib: "\u7EC4\u4EF6\u5E93",
    formLib: "\u8868\u5355\u6A21\u677F",
    containerTitle: "\u5BB9\u5668",
    dragHandlerHint: "\u9F20\u6807\u62D6\u62FD\u5BB9\u5668\u7EC4\u4EF6\u6216\u5B57\u6BB5\u7EC4\u4EF6\u5E76\u653E\u7F6E\u4E8E\u8868\u5355\u4E2D",
    dragAction: "\u62D6\u52A8",
    basicFieldTitle: "\u57FA\u7840\u5B57\u6BB5",
    advancedFieldTitle: "\u9AD8\u7EA7\u5B57\u6BB5",
    customFieldTitle: "\u81EA\u5B9A\u4E49\u6269\u5C55\u5B57\u6BB5",
    chartTitle: "\u56FE\u8868\u7EC4\u4EF6",
    noWidgetHint: "\u8BF7\u4ECE\u5DE6\u4FA7\u5217\u8868\u4E2D\u9009\u62E9\u4E00\u4E2A\u7EC4\u4EF6, \u7136\u540E\u7528\u9F20\u6807\u62D6\u52A8\u7EC4\u4EF6\u653E\u7F6E\u4E8E\u6B64\u5904.",
    widgetLabel: {
      grid: "\u6805\u683C",
      'column-1-grid': "\u5355\u5217\u6805\u683C",
      'column-2-grid': "\u53CC\u5217\u6805\u683C",
      'column-3-grid': "\u4E09\u5217\u6805\u683C",
      'column-4-grid': "\u56DB\u5217\u6805\u683C",
      table: "\u8868\u683C",
      tab: "\u6807\u7B7E\u9875",
      section: "\u533A\u5757",
      'sub-form': "\u5355\u884C\u5B50\u8868\u5355",
      'grid-sub-form': "\u591A\u884C\u5B50\u8868\u5355",
      'grid-col': "\u6805\u683C\u5217",
      'table-cell': "\u5355\u5143\u683C",
      'tab-pane': "\u9009\u9879\u5361\u9875",
      'data-table': "\u6570\u636E\u8868\u683C",
      tree: "\u6811\u5F62",
      'button-group': "\u6309\u94AE\u7EC4",
      'object-group': "\u5BF9\u8C61\u5BB9\u5668",
      'vf-dialog': "\u5F39\u51FA\u7A97\u53E3",
      'vf-drawer': "\u4FA7\u6ED1\u62BD\u5C49",
      input: "\u5355\u884C\u8F93\u5165",
      textarea: "\u591A\u884C\u8F93\u5165",
      number: "\u8BA1\u6570\u5668",
      radio: "\u5355\u9009\u9879",
      checkbox: "\u591A\u9009\u9879",
      select: "\u4E0B\u62C9\u9009\u9879",
      time: "\u65F6\u95F4",
      'time-range': "\u65F6\u95F4\u8303\u56F4",
      date: "\u65E5\u671F",
      'date-range': "\u65E5\u671F\u8303\u56F4",
      switch: "\u5F00\u5173",
      rate: "\u8BC4\u5206",
      color: "\u989C\u8272\u9009\u62E9\u5668",
      slider: "\u6ED1\u5757",
      'static-text': "\u9759\u6001\u6587\u5B57",
      'html-text': 'HTML',
      button: "\u6309\u94AE",
      divider: "\u5206\u9694\u7EBF",
      'picture-upload': "\u56FE\u7247",
      'file-upload': "\u6587\u4EF6",
      'rich-editor': "\u5BCC\u6587\u672C",
      cascader: "\u7EA7\u8054\u9009\u62E9",
      slot: "\u63D2\u69FD",
      custom: 'Custom Component'
    },
    hint: {
      formulaSetting: "\u516C\u5F0F\u8BBE\u7F6E",
      formulaModel: "\u6A21\u5F0F",
      formulaModelView: "\u67E5\u770B",
      formulaModelEdit: "\u7F16\u8F91",
      formulaSize: "\u5927\u5C0F",
      formulaSizeLarge: "\u5927",
      formulaSizeMedium: "\u4E2D",
      formulaSizeSmall: "\u5C0F",
      formulaSizeMini: "\u8FF7\u4F60",
      formulaClear: "\u6E05\u9664",
      formulaNum: "\u6570\u5B57",
      formulaStr: "\u5B57\u7B26",
      formulaOK: "\u786E\u5B9A",
      formulaSearch: "\u641C\u7D22...",
      formulaWidgetList: "\u7EC4\u4EF6\u5217\u8868",
      formulaFunctionList: "\u51FD\u6570\u5217\u8868",
      formulaFunctionExplain: "\u51FD\u6570\u8BF4\u660E",
      formulaFunctionMaths: "\u6570\u5B66\u51FD\u6570",
      formulaFunctionLogic: "\u903B\u8F91\u51FD\u6570",
      formulaFunctionTime: "\u65F6\u95F4\u51FD\u6570",
      formulaFunctionString: "\u5B57\u7B26\u4E32\u51FD\u6570",
      formulaNumber: "\u6570\u5B57",
      formulaObject: "\u5BF9\u8C61",
      formulaDate: "\u65E5\u671F",
      formulaChar: "\u6587\u5B57",
      formulaPleaseSelect: "\u8BF7\u9009\u62E9\u7EC4\u4EF6\u540D\u548C\u51FD\u6570",
      formulaSample: "\u516C\u5F0F\u7F16\u8F91\u4E3E\u4F8B",
      formulaPara: "\u53C2\u6570",
      formulaINT: "\u5C06\u6570\u503C\u53BB\u6389\u5C0F\u6570\uFF0C\u4E3E\u4F8B\uFF1AINT(-8.9)=-9",
      formulaSUM: "\u8FD4\u56DE\u4E00\u7EC4\u6570\u636E\u7684\u548C\uFF0C\u4E3E\u4F8B\uFF1ASUM(1,2,3,...)=6",
      formulaAVERAGE: "\u8FD4\u56DE\u4E00\u7EC4\u6570\u636E\u7684\u5E73\u5747\u6570\uFF0C\u4E3E\u4F8B\uFF1AAVERAGE(1,2,3,...)=2",
      formulaMAX: "\u8FD4\u56DE\u4E00\u7EC4\u6570\u4E2D\u7684\u6700\u5927\u503C\uFF0C\u4E3E\u4F8B\uFF1AMAX(1,2,3,...)=3",
      formulaMIN: "\u8FD4\u56DE\u4E00\u7EC4\u6570\u4E2D\u7684\u6700\u5C0F\u503C\uFF0C\u4E3E\u4F8B\uFF1AMIN(1,2,3,...)=1",
      formulaABS: "\u6C42\u4E00\u4E2A\u6570\u7684\u7EDD\u5BF9\u503C\uFF0C\u4E3E\u4F8B\uFF1AABS(-5)=5",
      formulaROUND: "\u5C06\u6570\u503C\u4FDD\u7559\u6307\u5B9A\u5C0F\u6570\u4F4D\uFF0C\u4E3E\u4F8B\uFF1AROUND(8.999,2)=9.00",
      formulaCEILING: "\u5C06\u4E00\u4E2A\u6570\u5411\u4E0A\u53D6\u6574\uFF0C\u4E3E\u4F8B\uFF1ACEILING(8.9)=9",
      formulaLOG: "\u8FD4\u56DE\u4EE5\u53C2\u65702\u4E3A\u5E95\u53C2\u65701\u7684\u5BF9\u6570\uFF0C\u4E3E\u4F8B\uFF1ALOG(8,2)=3\uFF0C\u4EE52\u4E3A\u5E958\u7684\u5BF9\u6570\u4E3A3",
      formulaMOD: "\u6C42\u4E24\u6570\u76F8\u9664\u7684\u4F59\u6570\uFF0C\u4E3E\u4F8B\uFF1AMOD(2,6)=2",
      formulaPOWER: "\u6C42\u6570\u5B57\u7684N\u6B21\u65B9\uFF0C\u4E3E\u4F8B\uFF1APOWER(5, 3)=125",
      formulaAND: "\u5F53\u6240\u6709\u6761\u4EF6\u90FD\u7B26\u5408\u65F6\uFF0C\u8FD4\u56DEtrue\uFF0C\u5426\u5219\u8FD4\u56DEfalse\uFF0C\u4E3E\u4F8B\uFF1AAND(1>0,2>1,...)=TRUE",
      formulaIF: "\u5224\u65AD\u4E00\u4E2A\u6761\u4EF6\u80FD\u5426\u6EE1\u8DB3\uFF0C\u5982\u679C\u6EE1\u8DB3\u5219\u8FD4\u56DE\u4E00\u4E2A\u503C\uFF0C\u5982\u679C\u4E0D\u6EE1\u8DB3\u5219\u8FD4\u56DE\u53E6\u4E00\u4E2A\u503C\uFF0C\u4E3E\u4F8B\uFF1AIF(1>2,1,0)=0",
      formulaIFS: "\u4E3E\u4F8B\uFF1AIFS(false, 'Hello!', true, 'Goodbye!')=Goodbye!",
      formulaIFERROR: "\u4E3E\u4F8B\uFF1AIFERROR('#DIV/0!', 'Error')",
      formulaIFNA: "\u4E3E\u4F8B\uFF1AIFNA('#N/A', 'Error')",
      formulaNOT: "\u4E3E\u4F8B\uFF1ANOT(true)=false",
      formulaOR: "\u4E3E\u4F8B: OR (true, false, true)=true",
      formulaSWITCH: "SWITCH(\u53C2\u6570\u503C,\u6761\u4EF61,'\u6761\u4EF6\u503C1',\u6761\u4EF62,'\u6761\u4EF6\u503C2'[,\u6761\u4EF6N,'\u6761\u4EF6\u503CN',])\uFF0C\u4E3E\u4F8B\uFF1ASWITCH(7, 9, 'Nine', 7, 'Seven')=Seven",
      formulaXOR: "\u4E3E\u4F8B\uFF1AXOR(true, false, true)=false",
      formulaYEAR: "\u4E3E\u4F8B\uFF1AYEAR(\"2022-10-1\")=2022",
      formulaMONTH: "\u4E3E\u4F8B\uFF1AMONTH(\"2022-10-1\")=10",
      formulaDAY: "\u4E3E\u4F8B\uFF1ADAY(\"2022-10-11\")=11",
      formulaTODAY: "\u4E3E\u4F8B: TODAY()=\"2022-10-11\"",
      formulaNOW: "\u4E3E\u4F8B: NOW=\"2022-10-11 17:04:33\"",
      formulaEMONTH: "\u4E3E\u4F8B: EMONTH ('2022-12-13  ', -1)='2022-11-13 '",
      formulaEDAY: "\u4E3E\u4F8B: EMONTH ('2022-12-13  ', -1)='2022-12-12 '",
      formulaFIND: "\u67E5\u627E\u5B57\u7B26\u4E32(\u53C2\u6570\uFF1A\n1\u3001\u67E5\u627E\u53E5\u67C4 2\u3001\u67E5\u627E\u76EE\u6807\u5B57\u7B26\u4E32 3\u3001\u5F00\u59CB\u67E5\u627E\u4E0B\u6807)\uFF0C\n\u4E3E\u4F8B\uFF1AFIND('M', 'Miriam McGovern', 3)=8",
      formulaLEFT: "\u83B7\u53D6\u5B57\u7B26\u4E32\u5DE6\u4FA7N\u4E2A\u5B57\u7B26\uFF0CLEFT(\u5B57\u7B26\u4E32,\u622A\u53D6\u957F\u5EA6)\uFF0C\u4E3E\u4F8B\uFF1ALEFT('Sale Price', 4)=Sale",
      formulaRIGHT: "\u83B7\u53D6\u5B57\u7B26\u4E32\u53F3\u4FA7N\u4E2A\u5B57\u7B26 RIGHT(\u5B57\u7B26\u4E32,\u622A\u53D6\u957F\u5EA6)\uFF0C\u4E3E\u4F8B\uFF1ARIGHT('Sale Price', 5)=Price",
      formulaLEN: "\u7EDF\u8BA1\u5B57\u7B26\u4E32\u957F\u5EA6\uFF0C\u4E3E\u4F8B\uFF1ALEN('abcdefgh')=8",
      formulaLOWER: "\u5B57\u7B26\u4E32\u8F6C\u5C0F\u5199\uFF0C\u4E3E\u4F8B\uFF1ALOWER('E. E. Cummings')=e. e. cummings",
      formulaUPPER: "\u5B57\u7B26\u4E32\u8F6C\u5927\u5199\uFF0C\u4E3E\u4F8B\uFF1AUPPER('total')=TOTAL",
      formulaMID: "\u622A\u53D6\u5B57\u7B26\u4E32 MID(\u5B57\u7B26\u4E32,\u5F00\u59CB\u4E0B\u6807,\u622A\u53D6\u957F\u5EA6)\uFF0C\u4E3E\u4F8B\uFF1AMID('Fluid Flow', 7, 20)=Flow",
      formulaTRIM: "\u5B57\u7B26\u4E32\u53BB\u9664\u591A\u4F59\u7A7A\u683C TRIM(\u5B57\u7B26\u4E32)\uFF0C\u4E3E\u4F8B\uFF1ATRIM('     First     Quarter  ')=First Quarter",
      formulaDateError: "\u65E5\u671F\u683C\u5F0F\u4E0D\u6B63\u786E",
      formulaDateErrorMsg: "\u65E5\u671F\u8F6C\u6362\u9519\u8BEF\u660E\u7EC6",
      selectParentWidget: "\u9009\u4E2D\u7236\u7EC4\u4EF6",
      moveUpWidget: "\u4E0A\u79FB\u7EC4\u4EF6",
      moveDownWidget: "\u4E0B\u79FB\u7EC4\u4EF6",
      cloneWidget: "\u590D\u5236\u7EC4\u4EF6",
      insertRow: "\u63D2\u5165\u65B0\u884C",
      insertColumn: "\u63D2\u5165\u65B0\u5217",
      remove: "\u79FB\u9664\u7EC4\u4EF6",
      cellSetting: "\u5355\u5143\u683C\u64CD\u4F5C",
      dragHandler: "\u62D6\u62FD\u624B\u67C4",
      copyField: "\u590D\u5236\u5B57\u6BB5\u7EC4\u4EF6",
      onlyFieldWidgetAcceptable: "\u5B50\u8868\u5355\u53EA\u80FD\u63A5\u6536\u5B57\u6BB5\u7EC4\u4EF6",
      moveUpFirstChildHint: "\u5DF2\u7ECF\u79FB\u52A8\u5230\u6700\u4E0A\u9762",
      moveDownLastChildHint: "\u5DF2\u7ECF\u79FB\u52A8\u5230\u6700\u4E0B\u9762",
      closePreview: "\u5173\u95ED",
      copyJson: "\u590D\u5236JSON",
      saveFormJson: "\u4FDD\u5B58\u4E3A\u6587\u4EF6",
      copyVueCode: "\u590D\u5236Vue\u4EE3\u7801",
      copyHtmlCode: "\u590D\u5236HTML\u4EE3\u7801",
      copyJsonSuccess: "\u590D\u5236JSON\u6210\u529F",
      importJsonSuccess: "\u5BFC\u5165JSON\u6210\u529F",
      invalidJsonFormat: "\u65E0\u6548\u7684\u8868\u5355JSON\u683C\u5F0F",
      jsonVersionMismatch: "\u8868\u5355JSON\u7248\u672C\u53F7\u4E0D\u5339\u914D",
      copyJsonFail: "\u590D\u5236JSON\u5931\u8D25",
      copyVueCodeSuccess: "\u590D\u5236Vue\u4EE3\u7801\u6210\u529F",
      copyVueCodeFail: "\u590D\u5236Vue\u4EE3\u7801\u5931\u8D25",
      copyHtmlCodeSuccess: "\u590D\u5236HTML\u4EE3\u7801\u6210\u529F",
      copyHtmlCodeFail: "\u590D\u5236HTML\u4EE3\u7801\u5931\u8D25",
      saveVueCode: "\u4FDD\u5B58Vue\u6587\u4EF6",
      saveHtmlCode: "\u4FDD\u5B58Html\u6587\u4EF6",
      getFormData: "\u83B7\u53D6\u6570\u636E",
      resetForm: "\u91CD\u7F6E\u8868\u5355",
      disableForm: "\u7981\u7528\u7F16\u8F91",
      enableForm: "\u6062\u590D\u7F16\u8F91",
      switchReadMode: "\u53EA\u8BFB\u67E5\u770B",
      exportFormData: "\u8868\u5355\u6570\u636E",
      copyFormData: "\u590D\u5236JSON",
      saveFormData: "\u4FDD\u5B58\u4E3A\u6587\u4EF6",
      copyVue2SFC: "\u590D\u5236Vue2\u4EE3\u7801",
      copyVue3SFC: "\u590D\u5236Vue3\u4EE3\u7801",
      copySFCFail: "\u590D\u5236SFC\u4EE3\u7801\u5931\u8D25",
      copySFCSuccess: "\u590D\u5236SFC\u4EE3\u7801\u6210\u529F",
      saveVue2SFC: "\u4FDD\u5B58\u4E3AVue2\u7EC4\u4EF6",
      saveVue3SFC: "\u4FDD\u5B58\u4E3AVue3\u7EC4\u4EF6",
      fileNameForSave: "\u6587\u4EF6\u540D\uFF1A",
      saveFileTitle: "\u4FDD\u5B58\u4E3A\u6587\u4EF6",
      fileNameInputPlaceholder: "\u8BF7\u8F93\u5165\u6587\u4EF6\u540D",
      sampleLoadedSuccess: "\u8868\u5355\u793A\u4F8B\u52A0\u8F7D\u6210\u529F",
      sampleLoadedFail: "\u8868\u5355\u793A\u4F8B\u52A0\u8F7D\u5931\u8D25",
      loadFormTemplate: "\u52A0\u8F7D\u6B64\u6A21\u677F",
      loadFormTemplateHint: "\u662F\u5426\u52A0\u8F7D\u8FD9\u4E2A\u6A21\u677F\uFF1F\u52A0\u8F7D\u540E\u4F1A\u8986\u76D6\u8BBE\u8BA1\u5668\u5F53\u524D\u8868\u5355\uFF0C\u4F60\u53EF\u4EE5\u4F7F\u7528\u201C\u64A4\u9500\u201D\u529F\u80FD\u6062\u590D\u3002",
      loadFormTemplateSuccess: "\u8868\u5355\u6A21\u677F\u52A0\u8F7D\u6210\u529F",
      loadFormTemplateFailed: "\u8868\u5355\u6A21\u677F\u52A0\u8F7D\u5931\u8D25",
      currentNodeCannotBeSelected: "\u5F53\u524D\u7EC4\u4EF6\u8282\u70B9\u4E0D\u53EF\u9009\u62E9",
      noSelectedWidgetHint: "\u5F53\u524D\u6CA1\u6709\u9009\u4E2D\u8BBE\u7F6E\u7684\u7EC4\u4EF6",
      widgetSetting: "\u7EC4\u4EF6\u8BBE\u7F6E",
      formSetting: "\u5168\u5C40\u8BBE\u7F6E",
      prompt: "\u63D0\u793A",
      confirm: "\u786E\u5B9A",
      cancel: "\u53D6\u6D88",
      import: "\u5BFC\u5165",
      importJsonHint: "\u5BFC\u5165\u7684JSON\u5185\u5BB9\u987B\u7B26\u5408\u4E0B\u8FF0\u683C\u5F0F\uFF0C\u4EE5\u4FDD\u8BC1\u987A\u5229\u5BFC\u5165.",
      importDSHint: "\u5BFC\u5165\u7684\u6570\u636E\u6E90\u683C\u5F0F\u987B\u7B26\u5408\u89C4\u8303\uFF0C\u4EE5\u4FDD\u8BC1\u987A\u5229\u5BFC\u5165.",
      invalidOptionsData: "\u65E0\u6548\u7684\u9009\u9879\u6570\u636E:",
      lastPaneCannotBeDeleted: "\u4EC5\u5269\u4E00\u4E2A\u9009\u9879\u5361\u9875\u4E0D\u53EF\u5220\u9664.",
      duplicateName: "\u7EC4\u4EF6\u540D\u79F0\u5DF2\u5B58\u5728: ",
      nameRequired: "\u7EC4\u4EF6\u540D\u79F0\u4E0D\u53EF\u4E3A\u7A7A",
      objectNameRequired: "\u5BF9\u8C61\u540D\u79F0\u4E0D\u53EF\u4E3A\u7A7A",
      numberValidator: "\u6570\u5B57",
      letterValidator: "\u5B57\u6BCD",
      letterAndNumberValidator: "\u6570\u5B57\u5B57\u6BCD",
      mobilePhoneValidator: "\u624B\u673A\u53F7\u7801",
      emailValidator: "\u90AE\u7BB1",
      urlValidator: "\u7F51\u5740",
      noChineseValidator: "\u975E\u4E2D\u6587\u5B57\u7B26",
      chineseValidator: "\u4EC5\u4E2D\u6587\u5B57\u7B26",
      rowspanNotConsistentForMergeEntireRow: "\u5B58\u5728\u884C\u9AD8\u4E0D\u4E00\u81F4\u7684\u5355\u5143\u683C, \u65E0\u6CD5\u5408\u5E76\u6574\u884C.",
      colspanNotConsistentForMergeEntireColumn: "\u5B58\u5728\u5217\u5BBD\u4E0D\u4E00\u81F4\u7684\u5355\u5143\u683C, \u65E0\u6CD5\u5408\u5E76\u6574\u5217.",
      rowspanNotConsistentForDeleteEntireRow: "\u5B58\u5728\u884C\u9AD8\u4E0D\u4E00\u81F4\u7684\u5355\u5143\u683C, \u4E0D\u53EF\u5220\u9664\u6574\u884C.",
      colspanNotConsistentForDeleteEntireColumn: "\u5B58\u5728\u5217\u5BBD\u4E0D\u4E00\u81F4\u7684\u5355\u5143\u683C, \u4E0D\u53EF\u5220\u9664\u6574\u5217.",
      lastColCannotBeDeleted: "\u6700\u540E\u4E00\u5217\u4E0D\u53EF\u5220\u9664.",
      lastRowCannotBeDeleted: "\u6700\u540E\u4E00\u884C\u4E0D\u53EF\u5220\u9664."
    },
    toolbar: {
      undoHint: "\u64A4\u9500",
      redoHint: "\u91CD\u505A",
      pcLayout: 'PC',
      padLayout: 'Pad',
      mobileLayout: 'H5',
      nodeTreeHint: "\u7EC4\u4EF6\u5C42\u6B21\u7ED3\u6784\u6811",
      nodeTreeTitle: "\u7EC4\u4EF6\u5C42\u6B21\u7ED3\u6784\u6811",
      clear: "\u6E05\u7A7A",
      preview: "\u9884\u89C8",
      importJson: "\u5BFC\u5165JSON",
      exportJson: "\u5BFC\u51FAJSON",
      exportCode: "\u5BFC\u51FA\u4EE3\u7801",
      generateCode: "\u751F\u6210\u4EE3\u7801",
      generateSFC: "\u751F\u6210SFC"
    },
    setting: {
      basicSetting: "\u57FA\u672C\u5C5E\u6027",
      attributeSetting: "\u5C5E\u6027\u8BBE\u7F6E",
      commonSetting: "\u5E38\u89C1\u5C5E\u6027",
      advancedSetting: "\u9AD8\u7EA7\u5C5E\u6027",
      eventSetting: "\u4E8B\u4EF6\u5C5E\u6027",
      uniqueName: "\u552F\u4E00\u540D\u79F0",
      editNameHelp: "\u4FEE\u6539\u540D\u79F0\u540E\u9700\u6309\u56DE\u8F66\u786E\u8BA4",
      keyNameEnabled: "\u4FEE\u6539\u6570\u636E\u5C5E\u6027\u540D\u79F0",
      keyName: "\u6570\u636E\u5C5E\u6027\u540D\u79F0",
      keyNameHelp: "\u6570\u636E\u5C5E\u6027\u540D\u79F0\u662F\u6307form-data\u5BF9\u8C61\u4E2D\u5B57\u6BB5\u7EC4\u4EF6\u6240\u5BF9\u5E94\u7684\u5C5E\u6027\u540D\u79F0",
      objectName: "\u5BF9\u8C61\u540D\u79F0",
      objectNameHelp: "\u5BF9\u8C61\u540D\u79F0\u683C\u5F0F\uFF1Aaa\u3001aa.bb\u6216aa.bb.cc",
      label: "\u6807\u7B7E",
      displayType: "\u663E\u793A\u7C7B\u578B",
      defaultValue: "\u9ED8\u8BA4\u503C",
      placeholder: "\u5360\u4F4D\u5185\u5BB9",
      startPlaceholder: "\u8D77\u59CB\u5360\u4F4D\u5185\u5BB9",
      endPlaceholder: "\u622A\u6B62\u5360\u4F4D\u5185\u5BB9",
      widgetColumnWidth: "\u7EC4\u4EF6\u5217\u5BBD",
      widgetSize: "\u7EC4\u4EF6\u5927\u5C0F",
      fontSize: "\u5B57\u4F53\u5927\u5C0F",
      textAlign: "\u6587\u5B57\u5BF9\u9F50",
      autoFullWidth: "\u81EA\u52A8\u62C9\u4F38\u5BBD\u5EA6",
      showStops: "\u663E\u793A\u95F4\u65AD\u70B9",
      displayStyle: "\u663E\u793A\u6837\u5F0F",
      inlineLayout: "\u884C\u5185",
      blockLayout: "\u5757",
      buttonStyle: "\u663E\u793A\u4E3A\u6309\u94AE",
      border: "\u5E26\u6709\u8FB9\u6846",
      labelWidth: "\u6807\u7B7E\u5BBD\u5EA6",
      rows: "\u884C\u6570",
      autosize: "\u81EA\u52A8\u9002\u5E94\u9AD8\u5EA6",
      labelHidden: "\u9690\u85CF\u5B57\u6BB5\u6807\u7B7E",
      labelWrap: "\u6807\u7B7E\u8D85\u957F\u6362\u884C",
      required: "\u5FC5\u586B\u5B57\u6BB5",
      requiredHint: "\u5FC5\u586B\u6821\u9A8C\u63D0\u793A",
      validation: "\u5B57\u6BB5\u6821\u9A8C",
      validationHelp: "\u652F\u6301\u8F93\u5165\u6B63\u5219\u8868\u8FBE\u5F0F",
      validationHint: "\u6821\u9A8C\u5931\u8D25\u63D0\u793A",
      readonly: "\u53EA\u8BFB",
      disabled: "\u7981\u7528",
      hidden: "\u9690\u85CF",
      textContent: "\u9759\u6001\u6587\u5B57",
      preWrap: "\u81EA\u52A8\u6362\u884C",
      htmlContent: 'HTML',
      clearable: "\u53EF\u6E05\u9664",
      editable: "\u53EF\u8F93\u5165",
      format: "\u663E\u793A\u683C\u5F0F",
      valueFormat: "\u7ED1\u5B9A\u503C\u683C\u5F0F",
      showPassword: "\u53EF\u663E\u793A\u5BC6\u7801",
      filterable: "\u53EF\u641C\u7D22\u9009\u9879",
      allowCreate: "\u5141\u8BB8\u521B\u5EFA\u9009\u9879",
      remote: "\u53EF\u8FDC\u7A0B\u641C\u7D22",
      automaticDropdown: "\u81EA\u52A8\u5F39\u51FA\u9009\u9879",
      multiple: "\u9009\u9879\u53EF\u591A\u9009",
      multipleLimit: "\u591A\u9009\u6570\u91CF\u9650\u5236",
      collapseTags: "\u6298\u53E0\u5DF2\u9009\u9879",
      checkStrictly: "\u4EFB\u610F\u7EA7\u8282\u70B9\u53EF\u9009",
      showAllLevels: "\u663E\u793A\u5B8C\u6574\u8DEF\u5F84",
      areaDataEnabled: "\u4F7F\u7528\u5730\u533A\u6570\u636E",
      contentPosition: "\u6587\u5B57\u4F4D\u7F6E",
      dividerDirection: "\u5206\u5272\u7EBF\u65B9\u5411",
      plain: "\u6734\u7D20\u6309\u94AE",
      round: "\u5706\u89D2\u6309\u94AE",
      circle: "\u5706\u5F62\u6309\u94AE",
      icon: "\u56FE\u6807",
      optionsSetting: "\u9009\u9879\u8BBE\u7F6E",
      optionValueType: "\u9009\u9879\u503C\u7C7B\u578B",
      addOption: "\u589E\u52A0\u9009\u9879",
      importOptions: "\u5BFC\u5165\u9009\u9879",
      resetDefault: "\u91CD\u8BBE\u9009\u4E2D\u9879",
      uploadSetting: "\u4E0A\u4F20\u53C2\u6570\u8BBE\u7F6E",
      uploadURL: "\u4E0A\u4F20\u5730\u5740",
      uploadTip: "\u4E0A\u4F20\u63D0\u793A\u5185\u5BB9",
      withCredentials: "\u53D1\u9001cookie\u51ED\u8BC1",
      multipleSelect: "\u6587\u4EF6\u53EF\u591A\u9009",
      showFileList: "\u663E\u793A\u6587\u4EF6\u5217\u8868",
      limit: "\u6700\u5927\u4E0A\u4F20\u6570\u91CF",
      fileMaxSize: "\u6587\u4EF6\u5927\u5C0F\u9650\u5236(MB)",
      fileTypes: "\u4E0A\u4F20\u6587\u4EF6\u7C7B\u578B",
      fileTypesHelp: "\u652F\u6301\u6DFB\u52A0\u5176\u4ED6\u6587\u4EF6\u7C7B\u578B",
      headers: "\u4E0A\u4F20\u8BF7\u6C42\u5934",
      formulaEnabled: "\u542F\u7528\u8BA1\u7B97\u516C\u5F0F",
      formula: "\u8BA1\u7B97\u516C\u5F0F",
      cellWidth: "\u5BBD\u5EA6",
      cellHeight: "\u9AD8\u5EA6",
      wordBreak: "\u6587\u5B57\u81EA\u52A8\u6362\u884C",
      gridColHeight: "\u6805\u683C\u5217\u7EDF\u4E00\u9AD8\u5EA6(px)",
      gutter: "\u6805\u683C\u95F4\u9694(px)",
      columnSetting: "\u6805\u683C\u5C5E\u6027\u8BBE\u7F6E",
      colsOfGrid: "\u5F53\u524D\u6805\u683C\u5217:",
      colSpanTitle: "\u6805\u683C\u5BBD\u5EA6",
      colOffsetTitle: "\u5DE6\u4FA7\u95F4\u9694\u683C\u6570",
      colPushTitle: "\u53F3\u79FB\u6805\u683C\u6570",
      colPullTitle: "\u5DE6\u79FB\u6805\u683C\u6570",
      addColumn: "\u589E\u52A0\u6805\u683C",
      responsive: "\u54CD\u5E94\u5F0F\u5E03\u5C40",
      tabType: "\u6807\u7B7E\u6837\u5F0F",
      tabPosition: "\u6807\u7B7E\u4F4D\u7F6E ",
      tabPaneSetting: "\u9009\u9879\u5361\u8BBE\u7F6E",
      addTabPane: "\u589E\u52A0\u9009\u9879\u5361\u9875",
      paneActive: "\u6FC0\u6D3B",
      customLabelIcon: "\u5B9A\u5236\u5B57\u6BB5\u6807\u7B7E",
      labelIconClass: "\u6807\u7B7EIcon\u6837\u5F0F",
      labelIconPosition: "\u6807\u7B7EIcon\u4F4D\u7F6E",
      labelTooltip: "\u6807\u7B7E\u6587\u5B57\u63D0\u793A",
      minValue: "\u6700\u5C0F\u503C",
      maxValue: "\u6700\u5927\u503C",
      precision: "\u7CBE\u5EA6",
      step: "\u589E\u51CF\u6B65\u957F",
      showControls: "\u663E\u793A\u63A7\u5236\u6309\u94AE",
      controlsPosition: "\u63A7\u5236\u6309\u94AE\u4F4D\u7F6E",
      minLength: "\u6700\u5C0F\u957F\u5EA6",
      maxLength: "\u6700\u5927\u957F\u5EA6",
      showWordLimit: "\u663E\u793A\u5B57\u6570\u7EDF\u8BA1",
      prefixIcon: "\u5934\u90E8Icon",
      suffixIcon: "\u5C3E\u90E8Icon",
      inputButton: "\u8F93\u5165\u6846\u6309\u94AE\u8BBE\u7F6E",
      appendButton: "\u6DFB\u52A0\u540E\u7F6E\u6309\u94AE",
      appendButtonDisabled: "\u540E\u7F6E\u6309\u94AE\u7981\u7528",
      appendButtonIcon: "\u540E\u7F6E\u6309\u94AEIcon",
      buttonIcon: "\u6309\u94AEIcon",
      appendText: "\u6DFB\u52A0\u540E\u7F6E\u6587\u5B57",
      textForAppend: "\u540E\u7F6E\u6587\u5B57\u5185\u5BB9",
      switchWidth: "\u5F00\u5173\u5BBD\u5EA6\uFF08\u50CF\u7D20\uFF09",
      activeText: "\u5F00\u542F\u65F6\u6587\u5B57\u63CF\u8FF0",
      inactiveText: "\u5173\u95ED\u65F6\u6587\u5B57\u63CF\u8FF0",
      activeColor: "\u5F00\u542F\u65F6\u80CC\u666F\u8272",
      inactiveColor: "\u5173\u95ED\u65F6\u80CC\u666F\u8272",
      maxStars: "\u6700\u5927\u8BC4\u5206\u503C",
      lowThreshold: "\u4F4E\u5206\u754C\u9650\u503C",
      highThreshold: "\u9AD8\u5206\u754C\u9650\u503C",
      allowHalf: "\u5141\u8BB8\u534A\u9009",
      showText: "\u663E\u793A\u8F85\u52A9\u6587\u5B57",
      showScore: "\u663E\u793A\u5F53\u524D\u5206\u6570",
      range: "\u662F\u5426\u4E3A\u8303\u56F4\u9009\u62E9",
      vertical: "\u662F\u5426\u7AD6\u5411\u663E\u793A",
      showBlankRow: "\u9ED8\u8BA4\u663E\u793A\u65B0\u884C",
      showRowNumber: "\u663E\u793A\u884C\u53F7",
      actionColumnPosition: "\u64CD\u4F5C\u5217\u4F4D\u7F6E",
      contentHeight: "\u5185\u5BB9\u533A\u9AD8\u5EA6",
      groupButtonsEdit: "\u6309\u94AE\u7F16\u8F91",
      insertColumnToLeft: "\u63D2\u5165\u5DE6\u4FA7\u5217",
      insertColumnToRight: "\u63D2\u5165\u53F3\u4FA7\u5217",
      insertRowAbove: "\u63D2\u5165\u4E0A\u65B9\u884C",
      insertRowBelow: "\u63D2\u5165\u4E0B\u65B9\u884C",
      mergeLeftColumn: "\u5408\u5E76\u5DE6\u4FA7\u5355\u5143\u683C",
      mergeRightColumn: "\u5408\u5E76\u53F3\u4FA7\u5355\u5143\u683C",
      mergeEntireRow: "\u5408\u5E76\u6574\u884C",
      mergeRowAbove: "\u5408\u5E76\u4E0A\u65B9\u5355\u5143\u683C",
      mergeRowBelow: "\u5408\u5E76\u4E0B\u65B9\u5355\u5143\u683C",
      mergeEntireColumn: "\u5408\u5E76\u6574\u5217",
      undoMergeCol: "\u64A4\u9500\u5217\u5408\u5E76",
      undoMergeRow: "\u64A4\u9500\u884C\u5408\u5E76",
      deleteEntireCol: "\u5220\u9664\u6574\u5217",
      deleteEntireRow: "\u5220\u9664\u6574\u884C",
      widgetName: "\u7EC4\u4EF6\u552F\u4E00\u540D\u79F0",
      formSize: "\u5168\u5C40\u7EC4\u4EF6\u5927\u5C0F",
      labelPosition: "\u5B57\u6BB5\u6807\u7B7E\u4F4D\u7F6E",
      topPosition: "\u9876\u90E8",
      leftPosition: "\u5DE6\u8FB9",
      labelAlign: "\u5B57\u6BB5\u6807\u7B7E\u5BF9\u9F50",
      leftAlign: "\u5C45\u5DE6",
      centerAlign: "\u5C45\u4E2D",
      rightAlign: "\u5C45\u53F3",
      formCss: "\u8868\u5355\u5168\u5C40CSS",
      addCss: "\u7F16\u5199CSS",
      customClass: "\u81EA\u5B9A\u4E49CSS\u6837\u5F0F",
      globalFunctions: "\u8868\u5355\u5168\u5C40\u51FD\u6570",
      addEventHandler: "\u7F16\u5199\u4EE3\u7801",
      editWidgetEventHandler: "\u7EC4\u4EF6\u4E8B\u4EF6\u5904\u7406",
      editFormEventHandler: "\u8868\u5355\u4E8B\u4EF6\u5904\u7406",
      formSFCSetting: "\u751F\u6210SFC\u8BBE\u7F6E",
      formModelName: "\u6570\u636E\u5BF9\u8C61\u540D\u79F0",
      formRefName: "\u5F15\u7528\u540D\u79F0",
      formRulesName: "\u9A8C\u8BC1\u89C4\u5219\u540D\u79F0",
      syntaxCheckWarning: "JS\u4EE3\u7801\u5B58\u5728\u8BED\u6CD5\u9519\u8BEF\uFF0C\u8BF7\u4ED4\u7EC6\u68C0\u67E5\uFF01",
      title: "\u6807\u9898",
      dialogWidth: "\u5F39\u7A97\u5BBD\u5EA6\uFF08px/%\uFF09",
      fullscreen: "\u5168\u5C4F\u663E\u793A\u5F39\u7A97",
      showModal: "\u663E\u793A\u906E\u7F69\u5C42",
      showClose: "\u663E\u793A\u5173\u95ED\u6309\u94AE",
      closeOnClickModal: "\u70B9\u51FB\u906E\u7F69\u5C42\u5173\u95ED",
      closeOnPressEscape: "\u6309Esc\u952E\u5173\u95ED",
      center: "\u5934\u90E8\u5E95\u90E8\u5C45\u4E2D",
      readMode: "\u5F39\u7A97\u8868\u5355\u53EA\u8BFB",
      disabledMode: "\u5F39\u7A97\u8868\u5355\u7981\u7528",
      okButtonLabel: "\u786E\u8BA4\u6309\u94AE\u6587\u5B57",
      okButtonHidden: "\u9690\u85CF\u786E\u8BA4\u6309\u94AE",
      cancelButtonLabel: "\u53D6\u6D88\u6309\u94AE\u6587\u5B57",
      cancelButtonHidden: "\u9690\u85CF\u53D6\u6D88\u6309\u94AE",
      drawSize: "\u62BD\u5C49\u5927\u5C0F\uFF08px/%\uFF09",
      drawDirection: "\u62BD\u5C49\u6ED1\u51FA\u65B9\u5411",
      tableWidth: "\u5BBD\u5EA6(px/%)",
      tableHeight: "\u9AD8\u5EA6(px/%)",
      showCheckBox: "\u662F\u5426\u663E\u793A\u590D\u9009\u6846\u5217",
      showIndex: "\u662F\u5426\u663E\u793A\u884C\u53F7",
      showPagination: "\u662F\u5426\u663E\u793A\u5206\u9875",
      smallPagination: "\u5C0F\u578B\u5206\u9875",
      paginationAlign: "\u5206\u9875\u6C34\u5E73\u5BF9\u9F50",
      autoColumnWidthDisabled: "\u7981\u7528\u5217\u5BBD\u81EA\u52A8\u5145\u6EE1",
      tableColEdit: "\u8868\u683C\u5217\u7F16\u8F91",
      tableDataEdit: "\u8868\u683C\u6570\u636E\u7F16\u8F91",
      showSummary: "\u662F\u5426\u5408\u8BA1",
      stripe: "\u662F\u5426\u6591\u9A6C\u7EBF",
      rowSpacing: "\u884C\u8DDD\uFF08px\uFF09",
      editAction: "\u7F16\u8F91...",
      columnName: "\u5B57\u6BB5\u540D\u79F0",
      columnLabel: "\u663E\u793A\u540D\u79F0",
      columnWidth: "\u5217\u5BBD(px)",
      visibleColumn: "\u662F\u5426\u663E\u793A",
      sortableColumn: "\u662F\u5426\u6392\u5E8F",
      customSortColumn: "\u540E\u7AEF\u6392\u5E8F",
      fixedColumn: "\u662F\u5426\u56FA\u5B9A",
      alignTypeOfColumn: "\u5BF9\u9F50\u65B9\u5F0F",
      formatOfColumn: "\u683C\u5F0F\u5316",
      customRenderGroup: "\u52A8\u6001\u6E32\u67D3",
      renderFunction: "\u6E32\u67D3\u51FD\u6570",
      actionColumn: "\u64CD\u4F5C",
      addTableColumn: "\u589E\u52A0\u5217",
      deleteTableColumn: "\u5220\u9664\u5217",
      onlyOneColumnCannotBeDeleted: "\u8868\u683C\u53EA\u6709\u4E00\u5217\u65F6\u4E0D\u53EF\u5220\u9664.",
      treeDataEnabled: "\u5141\u8BB8\u52A0\u8F7D\u6811\u5F62\u6570\u636E",
      rowKeyOfTreeData: "\u884C\u6570\u636EKey",
      childrenKeyOfTreeData: "\u6811\u5F62\u6570\u636E\u5B50\u8282\u70B9\u952E",
      showButtonsColumn: "\u663E\u793A\u64CD\u4F5C\u6309\u94AE\u5217",
      buttonsColumnEdit: "\u64CD\u4F5C\u6309\u94AE\u7F16\u8F91",
      buttonsColumnTitle: "\u5217\u6807\u9898",
      buttonsColumnWidth: "\u5217\u5BBD\u5EA6\uFF08px\uFF09",
      operationButtonsSetting: "\u64CD\u4F5C\u6309\u94AE\u8BBE\u7F6E",
      operationButtonName: "\u540D\u79F0",
      operationButtonLabel: "\u6587\u5B57",
      operationButtonType: "\u7C7B\u578B",
      operationButtonSize: "\u5927\u5C0F",
      operationButtonRound: "\u5706\u89D2",
      operationButtonHidden: "\u9690\u85CF",
      operationButtonDisabled: "\u7981\u7528",
      addOperationButton: "\u589E\u52A0\u6309\u94AE",
      deleteOperationButtonHint: "\u786E\u5B9A\u5220\u9664\u8BE5\u6309\u94AE\uFF1F",
      operationButtonDuplicatedNameError: "\u6309\u94AE\u540D\u79F0\u4E0D\u53EF\u91CD\u590D",
      tableHeader: "\u8868\u5934",
      insertTableHeader: "\u63D2\u5165\u8868\u5934",
      insertTableSubHeader: "\u63D2\u5165\u4E0B\u7EA7\u8868\u5934",
      tableDataColumn: "\u6570\u636E\u5217",
      insertTableDataColumn: "\u63D2\u5165\u6570\u636E\u5217",
      insertTableSubDataColumn: "\u63D2\u5165\u4E0B\u7EA7\u6570\u636E\u5217",
      onlyDragBetweenSiblingNodes: "\u53EA\u80FD\u5728\u540C\u7EA7\u8282\u70B9\u4E4B\u95F4\u8FDB\u884C\u62D6\u62FD\u6392\u5E8F\uFF01",
      getHeaderLevelTitle: function getHeaderLevelTitle(n) {
        return n + "\u7EA7\u8868\u5934";
      },
      lineNumber: "\u5E8F\u53F7",
      dsEnabled: "\u4F7F\u7528\u6570\u636E\u6E90",
      dsName: "\u6307\u5B9A\u6570\u636E\u6E90",
      dataSetName: "\u6307\u5B9A\u6570\u636E\u96C6",
      labelKeyName: "\u9009\u9879\u6807\u7B7E\u540D",
      valueKeyName: "\u9009\u9879\u503C\u540D",
      childrenKeyName: "\u5B50\u8282\u70B9\u5C5E\u6027\u540D\u79F0",
      dataSource: "\u6570\u636E\u6E90",
      noDataSource: "\u6682\u65E0\u6570\u636E\u6E90",
      addDataSource: "\u65B0\u589E\u6570\u636E\u6E90",
      importDataSource: "\u5BFC\u5165\u6570\u636E\u6E90",
      clearExistingDataSource: "\u5BFC\u5165\u540E\u6E05\u7A7A\u539F\u6709\u6570\u636E\u6E90",
      remainExistingDataSource: "\u8FFD\u52A0\u5230\u5DF2\u6709\u6570\u636E\u6E90\u4E4B\u540E",
      exportDataSource: "\u5BFC\u51FA\u6570\u636E\u6E90",
      selectDataSourceForExport: "\u9009\u62E9\u5BFC\u51FA\u6570\u636E\u6E90",
      dataSourceChecked: "\u9009\u4E2D\u5BFC\u51FA",
      previewDataSourceExportResult: "\u5BFC\u51FA\u7ED3\u679C\u9884\u89C8",
      dataSourceSetting: "\u6570\u636E\u6E90\u8BBE\u7F6E",
      deleteDataSourceHint: "\u786E\u8BA4\u5220\u9664\u8BE5\u6570\u636E\u6E90\uFF1F",
      fieldValueRequired: "\u8F93\u5165\u5185\u5BB9\u4E0D\u53EF\u4E3A\u7A7A",
      dsUniqueName: "\u552F\u4E00\u540D\u79F0",
      dsRequestURL: "\u8BF7\u6C42\u5730\u5740",
      dsRequestURLType: "\u8BF7\u6C42URL\u7C7B\u578B",
      dsURLStringType: "\u56FA\u5B9A\u5B57\u7B26\u4E32",
      dsURLVariableType: "\u53D8\u91CF\u6216\u8868\u8FBE\u5F0F",
      dsDescription: "\u63CF\u8FF0\u4FE1\u606F",
      dsRequestMethod: "\u8BF7\u6C42\u65B9\u6CD5",
      dsRequestHeaders: "\u8BF7\u6C42\u5934\uFF08headers\uFF09",
      addRequestHeader: "\u65B0\u589E\u8BF7\u6C42\u5934",
      dsRequestParams: "\u53C2\u6570\uFF08params\uFF09",
      addRequestParam: "\u65B0\u589E\u8BF7\u6C42\u53C2\u6570",
      dsRequestData: "\u53D1\u9001\u6570\u636E\uFF08data\uFF09",
      addRequestData: "\u65B0\u589E\u53D1\u9001\u6570\u636E",
      addDataSet: "\u65B0\u589E\u6570\u636E\u96C6",
      dsRequestValueStringType: "\u5B57\u7B26\u4E32\u7C7B\u578B",
      dsRequestValueNumberType: "\u6570\u503C\u7C7B\u578B",
      dsRequestValueBooleanType: "\u5E03\u5C14\u7C7B\u578B",
      dsRequestValueVariableType: "\u53D8\u91CF\u6216\u8868\u8FBE\u5F0F",
      dsRequestNameInputPlaceholder: "\u540D\u79F0",
      dsRequestTypeInputPlaceholder: "\u7C7B\u578B",
      dsRequestValueInputPlaceholder: "\u503C",
      dataSetRemarkInputPlaceholder: "\u5907\u6CE8\u8BF4\u660E",
      dsConfigHandlerTitle: "1. \u8BF7\u6C42\u914D\u7F6E",
      dsDataHandlerTitle: "2. \u6570\u636E\u5904\u7406",
      dsErrorHandlerTitle: "3. \u9519\u8BEF\u5904\u7406",
      dataSetSettingTitle: "4. \u591A\u6570\u636E\u96C6\u914D\u7F6E",
      dataSetEnabled: "\u5F00\u542F\u591A\u6570\u636E\u96C6\u8FD4\u56DE",
      dataSetSetting: "\u8FD4\u56DE\u6570\u636E\u96C6\u7BA1\u7406",
      testDataSource: "\u6D4B\u8BD5\u6570\u636E\u6E90",
      dsvTitle: "DSV\u6570\u636E\u6E90\u53D8\u91CF",
      dsRequestResult: "\u8FD4\u56DE\u6570\u636E",
      executeDataSource: "\u7ACB\u5373\u6267\u884C",
      clearRequestResult: "\u6E05\u7A7A\u7ED3\u679C",
      dsRequestNumberTypeError: "\u6570\u636E\u7C7B\u578B\u503C\u9519\u8BEF",
      dsRequestBooleanTypeError: "\u5E03\u5C14\u7C7B\u578B\u503C\u9519\u8BEF",
      dsValidationError: "\u6570\u636E\u6E90\u8BBE\u7F6E\u5B58\u5728\u9519\u8BEF\uFF0C\u8BF7\u4FEE\u6539",
      dsDuplicatedNameError: "\u6570\u636E\u6E90\u540D\u79F0\u91CD\u590D\uFF0C\u8BF7\u4FEE\u6539\uFF01",
      showTreeCheckBox: "\u663E\u793A\u590D\u9009\u6846",
      lazy: "\u61D2\u52A0\u8F7D",
      treeDataEdit: "\u6811\u6570\u636E\u7F16\u8F91",
      defaultExpandAllNode: "\u9ED8\u8BA4\u5C55\u5F00\u6240\u6709\u8282\u70B9",
      expandRetractAllNode: "\u5C55\u5F00/\u6536\u7F29",
      selectClearAllNode: "\u9009\u4E2D/\u53D6\u6D88\u9009\u4E2D",
      nodeEdit: "\u5141\u8BB8\u6DFB\u52A0\u5220\u9664\u8282\u70B9",
      expandAllNode: "\u5C55\u5F00\u6240\u6709",
      retractAllNode: "\u6536\u7F29\u6240\u6709",
      selectAllNode: "\u9009\u62E9\u6240\u6709",
      clearAllNode: "\u6E05\u9664\u6240\u6709",
      draggable: "\u5141\u8BB8\u62D6\u62FD\u8282\u70B9",
      filter: "\u663E\u793A\u8FC7\u6EE4\u6846",
      expandOnClickNode: "\u70B9\u51FB\u8282\u70B9\u53EF\u6536\u7F29",
      treeNodeCheckStrictly: "\u7981\u6B62\u7236\u5B50\u8282\u70B9\u8054\u52A8",
      inputNodeName: "\u8BF7\u8F93\u5165\u8282\u70B9\u540D",
      deleteNode: "\u786E\u5B9A\u5220\u9664\u8282\u70B9?",
      nodeDeleted: "\u8282\u70B9\u5DF2\u5220\u9664",
      tips: "\u63D0\u793A",
      onNodeCheckRemark: "\u6811\u8282\u70B9\u9009\u62E9\u4E8B\u4EF6",
      onNodeClickRemark: "\u6811\u8282\u70B9\u70B9\u51FB\u4E8B\u4EF6",
      onNodeContextmenuRemark: "\u6811\u8282\u70B9\u53F3\u51FB\u4E8B\u4EF6",
      enterForQuery: "\u8F93\u5165\u5173\u952E\u5B57\u8FDB\u884C\u8FC7\u6EE4",
      add: "\u6DFB\u52A0",
      delete: "\u5220\u9664"
    }
  }
};